// extracted by mini-css-extract-plugin
module.exports = {"t1v2vbab":"t1v2vbab","t1jehbg7":"t1jehbg7"};